import React, { FunctionComponent, useState, useReducer } from 'react'
import ReactCardFlip from 'react-card-flip'
import { EmissionBar } from '../emissionBar'
import { Image, Mdx } from '@ta-interaktiv/contentbricks'
import CardFront, { Props as CardFrontProps } from '../co2CardFront'

// var IntlMessageFormat = require('intl-messageformat')
import './styles.scss'
export interface Props {
  flight: string[]
  map: string
  perCapita: number
  show: string[]
  compensation: {
    [key: string]: [number, string]
    trees: [number, string]
    meat: [number, string]
    cars: [number, string]
    baskets: [number, string]
  }
}

const numberFormat = (n: number) => {
  return new Intl.NumberFormat('ch-DE').format(n)
}
export const CO2Viz: FunctionComponent<Props> = ({
  flight,
  map,
  perCapita,
  show,
  compensation
}: Props) => {
  const [firstFlipped, flipFirst] = useState(false)
  const [secondFlipped, flipSecond] = useState(false)
  const [thirdFlipped, flipThird] = useState(false)
  const [fourthFlipped, flipFourth] = useState(false)
  const [emissionsFlipped, flipEmissions] = useState(false)

  const shareOfCapita = ((+flight[2] * 100) / perCapita).toFixed(1)

  const flipDecider = (which: string, what: string) => {
    if (what === 'read') {
      switch (which) {
        case 'trees':
          return firstFlipped
        case 'cars':
          return secondFlipped
        case 'baskets':
          return thirdFlipped
        case 'meat':
          return fourthFlipped

        default:
          return false
      }
    } else {
      switch (which) {
        case 'trees':
          flipFirst(!firstFlipped)
          break
        case 'cars':
          flipSecond(!secondFlipped)
          break
        case 'baskets':
          flipThird(!thirdFlipped)
          break
        case 'meat':
          flipFourth(!fourthFlipped)
          break
      }
    }
  }

  return (
    <>
      <div className='ui vertical fitted segment' id='viz'>
        <div className='ui container'>
          <div className='bg'>
            <div className='contentBG' />
          </div>
          <div className='content'>
            <div className='ui text container'>
              <Image file={map} className='map' />
              <div className='vizText'>
                Eine Flugreise von <b>{flight[0]}</b> nach
                <b>{flight[1]}</b> und retour
                <br /> verursacht{' '}
                <b>
                  {numberFormat(+flight[2])} kg CO<sub>2</sub>
                </b>
                pro Person.
                <br />
                <img src='images/flowArrow.svg' className='flowArrow' />
              </div>
              {/* ---------------- JAHRESEMISSIONEN */}
              <ReactCardFlip
                isFlipped={emissionsFlipped}
                flipDirection='horizontal'
                containerStyle={{ minHeight: '200' }}
              >
                <div
                  key='front'
                  onClick={() => flipEmissions(!emissionsFlipped)}
                  className='front emissions'
                >
                  <div className='vizText emissions'>
                    Das entspricht{' '}
                    <b>{shareOfCapita.replace('.', ',')} Prozent </b>der
                    durchschnittlichen
                    <br />
                    Jahresemissionen eines Schweizers.
                  </div>
                  <span className='infoButton'>
                    {' '}
                    <i className='info circle icon' />
                    So wurde berechnet
                  </span>
                  <EmissionBar value={+shareOfCapita} />
                </div>

                <div
                  key='back'
                  onClick={() => flipEmissions(!emissionsFlipped)}
                  className='back emissions'
                >
                  <Mdx file={require('text/methode_budget.mdx')} />
                  <i className='window close icon' />
                </div>
              </ReactCardFlip>
              <img
                src={require('images/flowArrow.svg')}
                className='flowArrow'
              />
              <div className='vizText'>
                <b>
                  Um diese eine Reise zu kompensieren
                  <br />
                  müsste man zum Beispiel…
                </b>
              </div>
            </div>
            <div className='ui container'>
              <div className='ui stackable three column grid '>
                <div className='ui row'>
                  {show.map((s, i) => {
                    return (
                      <div className='column' key={i}>
                        <ReactCardFlip
                          isFlipped={flipDecider(s, 'read')}
                          flipDirection='horizontal'
                          containerStyle={{ minHeight: '420px' }}
                        >
                          <div
                            key='front'
                            onClick={() => flipDecider(s, 'flip')}
                            className='front'
                          >
                            <CardFront
                              type={s}
                              content={compensation[s]}
                              key={i}
                            />
                          </div>

                          <div
                            key='back'
                            onClick={() => flipDecider(s, 'flip')}
                            className='back vizText'
                          >
                            <Mdx file={require('text/methode_' + s + '.mdx')} />
                            <span className='infoButton'>
                              {' '}
                              <i className='info close icon' />
                              Schliessen
                            </span>
                          </div>
                        </ReactCardFlip>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
